/**
 * Quick Add image lightbox
 * Makes product images inside Horizon's Quick Add popup expandable.
 */

if (!window.__koQuickAddImageZoomInitialized) {
  window.__koQuickAddImageZoomInitialized = true;

  const MEDIA_SELECTOR =
    'quick-add-dialog ' +
    '.quick-add-modal__content ' +
    '.product-information__media ' +
    '.product-media-container--image';

  const DIALOG_ID = 'ko-quick-add-image-dialog';

  /**
   * Get the largest image available in the responsive srcset.
   */
  function getLargestImageSource(image) {
    const srcset = image.getAttribute('srcset');

    if (srcset) {
      const candidates = srcset
        .split(',')
        .map((candidate) => {
          const parts = candidate.trim().split(/\s+/);
          const descriptor = parts.pop() || '';
          const url = parts.join(' ');

          const width = descriptor.endsWith('w')
            ? Number.parseInt(descriptor, 10)
            : 0;

          return { url, width };
        })
        .filter((candidate) => candidate.url)
        .sort((a, b) => a.width - b.width);

      if (candidates.length) {
        return candidates[candidates.length - 1].url;
      }
    }

    return image.currentSrc || image.src;
  }

  /**
   * Create the shared expanded-image dialog.
   */
  function getImageDialog() {
    let dialog = document.getElementById(DIALOG_ID);

    if (dialog) return dialog;

    dialog = document.createElement('dialog');
    dialog.id = DIALOG_ID;
    dialog.className = 'ko-quick-add-image-dialog';

    dialog.innerHTML = `
      <div class="ko-quick-add-image-dialog__inner">
        <button
          type="button"
          class="ko-quick-add-image-dialog__close"
          aria-label="Close expanded image"
        >
          &times;
        </button>

        <img
          class="ko-quick-add-image-dialog__image"
          alt=""
        >
      </div>
    `;

    document.body.appendChild(dialog);

    const closeButton = dialog.querySelector(
      '.ko-quick-add-image-dialog__close'
    );

    const expandedImage = dialog.querySelector(
      '.ko-quick-add-image-dialog__image'
    );

    closeButton.addEventListener('click', () => {
      dialog.close();
    });

    /*
     * Close when the customer clicks the dark backdrop.
     */
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) {
        dialog.close();
      }
    });

    dialog.addEventListener('close', () => {
      expandedImage.removeAttribute('src');
      expandedImage.alt = '';
    });

    return dialog;
  }

  /**
   * Open the clicked Quick Add image.
   */
  function openExpandedImage(image) {
    const dialog = getImageDialog();

    const expandedImage = dialog.querySelector(
      '.ko-quick-add-image-dialog__image'
    );

    expandedImage.src = getLargestImageSource(image);
    expandedImage.alt = image.alt || 'Expanded product image';

    if (!dialog.open) {
      dialog.showModal();
    }
  }

  /**
   * Make dynamically loaded Quick Add images keyboard-accessible.
   */
  function enhanceQuickAddImages() {
    document.querySelectorAll(MEDIA_SELECTOR).forEach((container) => {
      if (!container.querySelector('img')) return;

      container.dataset.koQuickAddZoom = 'true';

      if (!container.hasAttribute('tabindex')) {
        container.tabIndex = 0;
      }

      if (!container.hasAttribute('role')) {
        container.setAttribute('role', 'button');
      }

      if (!container.hasAttribute('aria-label')) {
        container.setAttribute(
          'aria-label',
          'Expand product image'
        );
      }
    });
  }

  /*
   * Handle clicks on dynamically loaded Quick Add images.
   */
  document.addEventListener(
    'click',
    (event) => {
      const container = event.target.closest?.(
        `${MEDIA_SELECTOR}[data-ko-quick-add-zoom="true"]`
      );

      if (!container) return;

      const image = container.querySelector('img');

      if (!image) return;

      event.preventDefault();
      event.stopPropagation();

      openExpandedImage(image);
    },
    true
  );

  /*
   * Allow Enter or Space to expand the focused image.
   */
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Enter' && event.key !== ' ') return;

    const container = event.target.closest?.(
      `${MEDIA_SELECTOR}[data-ko-quick-add-zoom="true"]`
    );

    if (!container) return;

    const image = container.querySelector('img');

    if (!image) return;

    event.preventDefault();
    openExpandedImage(image);
  });

  /*
   * Quick Add content is injected dynamically, so watch for it.
   */
  const observer = new MutationObserver(() => {
    enhanceQuickAddImages();
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
  });

  enhanceQuickAddImages();
}